<div  class="dark-content eligibility-dialog loan {{tenureData.length > 1? 'options':''}}"><!-- add 'options' class for multiple -->
    <div class="dark-title">{{loanDetails.loanCommercialDetails?.length == 1
        ? 'Confirm your loan terms' : 'Select your loan terms'}}</div>
    <div class="option-list" >
      <div *ngIf=" (tenureData.length > 1)" class="or-text">or</div><!-- enable this for multiple -->
      <div class="loan-option" *ngFor="let term of tenureData; index as i">
        <div *ngIf="tenureData.length > 1" class="option-title">Option {{i+1}}</div><!-- enable this for multiple -->
        <div class="dark-inner">
            <div class="gradient-line"></div>
            <div class="dark-left">
                <img src="assets/images/eligibility/eligible_loan.svg" alt="Loan Image" />
                <div class="loan-text">You are eligible for a loan of </div>
                <div class="loan-amount"><span class="lite">₹</span>{{formator.format(term.amount)}}</div>
            </div>
            <div class="dark-right">
                <div class="det-list">
                    <div class="list-item">
                        <svg width="29" height="30" viewBox="0 0 29 30" fill="none">
                            <path
                                d="M24.1314 12.8694H20.7296C17.9398 12.8694 15.668 10.5976 15.668 7.80786V4.406C15.668 3.75858 15.1383 3.22888 14.4909 3.22888H9.49989C5.87437 3.22888 2.94336 5.58311 2.94336 9.78541V20.2146C2.94336 24.4169 5.87437 26.7712 9.49989 26.7712H18.752C22.3775 26.7712 25.3085 24.4169 25.3085 20.2146V14.0466C25.3085 13.3992 24.7788 12.8694 24.1314 12.8694Z"
                                fill="white" />
                            <path
                                d="M18.5977 3.47607C18.115 2.99346 17.2793 3.32305 17.2793 3.994V8.10213C17.2793 9.82072 18.7389 11.245 20.5164 11.245C21.6346 11.2568 23.1884 11.2568 24.5186 11.2568C25.1895 11.2568 25.5426 10.4681 25.0718 9.99729C23.3767 8.29047 20.3398 5.2182 18.5977 3.47607Z"
                                fill="#10D7EE" />
                            <path
                                d="M15.8908 17.06H8.82815C8.34553 17.06 7.94531 16.6598 7.94531 16.1771C7.94531 15.6945 8.34553 15.2943 8.82815 15.2943H15.8908C16.3735 15.2943 16.7737 15.6945 16.7737 16.1771C16.7737 16.6598 16.3735 17.06 15.8908 17.06Z"
                                fill="#17151C" />
                            <path
                                d="M13.5366 21.7685H8.82815C8.34553 21.7685 7.94531 21.3683 7.94531 20.8856C7.94531 20.403 8.34553 20.0028 8.82815 20.0028H13.5366C14.0192 20.0028 14.4194 20.403 14.4194 20.8856C14.4194 21.3683 14.0192 21.7685 13.5366 21.7685Z"
                                fill="#17151C" />
                        </svg>
                        <div class="name">Interest rate</div>
                        <div class="value">{{term.customerRoi}}% p.a</div>
                    </div>
                    <div class="list-item">
                        <svg width="27" height="27" viewBox="0 0 27 27" fill="none">
                            <g id="vuesax/bulk/coin">
                                <g id="coin">
                                    <path id="Vector"
                                        d="M11.2179 20.2403C16.1728 20.2403 20.1896 16.2235 20.1896 11.2685C20.1896 6.31355 16.1728 2.29675 11.2179 2.29675C6.26289 2.29675 2.24609 6.31355 2.24609 11.2685C2.24609 16.2235 6.26289 20.2403 11.2179 20.2403Z"
                                        fill="white" />
                                    <path id="Vector_2"
                                        d="M24.6695 18.0057C24.6695 21.7112 21.6602 24.7205 17.9547 24.7205C15.6641 24.7205 13.6541 23.5752 12.4414 21.8347C17.3371 21.2845 21.2335 17.3882 21.7837 12.4924C23.5242 13.7051 24.6695 15.7151 24.6695 18.0057Z"
                                        fill="#10D7EE" />
                                    <g id="Group 772544539">
                                        <path id="Vector_3"
                                            d="M14.5961 8.12219H8.75586H10.3487C10.9119 8.12219 11.4521 8.34594 11.8504 8.74422C12.2486 9.1425 12.4724 9.68268 12.4724 10.2459C12.4724 10.8092 12.2486 11.3494 11.8504 11.7476C11.4521 12.1459 10.9119 12.3697 10.3487 12.3697H8.75586L11.9415 15.5553"
                                            stroke="#17151C" stroke-width="1.17575" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path id="Vector_4" d="M8.75586 10.2479H14.5961" stroke="#17151C"
                                            stroke-width="1.17575" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <div class="name">Monthly EMI</div>
                        <div class="value">₹{{term.emi}}</div>
                    </div>
                    <div class="list-item">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g id="calendar-edit">
                                <g id="calendar-edit_2">
                                    <g id="Group">
                                        <path id="Vector"
                                            d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75022V2C8.75022 1.59 8.41022 1.25 8.00022 1.25C7.59022 1.25 7.25022 1.59 7.25022 2V3.56C4.55022 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
                                            fill="#10D7EE" />
                                        <path id="Vector_2"
                                            d="M20 9.83997C20.55 9.83997 21 10.29 21 10.84V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V10.84C3 10.29 3.45 9.83997 4 9.83997H20Z"
                                            fill="white" />
                                    </g>
                                    <g id="Group_2">
                                        <path id="Vector_3"
                                            d="M14.8409 14.9899L14.3409 15.4999H14.3309L11.3009 18.5299C11.1709 18.6599 10.9009 18.7999 10.7109 18.8199L9.36091 19.0199C8.87091 19.0899 8.53093 18.7399 8.60093 18.2599L8.79093 16.8999C8.82093 16.7099 8.95091 16.4499 9.08091 16.3099L12.1209 13.2799L12.6209 12.7699C12.9509 12.4399 13.3209 12.2 13.7209 12.2C14.0609 12.2 14.4309 12.3599 14.8409 12.7699C15.7409 13.6699 15.4509 14.3799 14.8409 14.9899Z"
                                            fill="black" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <div class="name">Tenure</div>
                        <div class="value">{{term.selectedTenor.tenor}}M</div>
                    </div>
                </div>
                <button class="btn-theme" (click)="submitTerms(term)">Accept these terms</button>
            </div>
        </div>
      </div>
    </div>
    <div *ngIf="showCoapplicant" class="loan-terms"><!-- enable this for multiple -->
      <div class="gradient-line"></div>
      <div class="img-sec">
        <img src="assets/images/eligibility/loan_terms_icon.svg" alt="Better Loan Terms"/>
      </div>
      <div class="det-sec">
        <div class="term-title">Looking for better loan terms?</div>
        <div class="term-info">Try {{applicantLength > 1 ? 'replacing' : 'adding'}} co-applicant  to qualify for a better loan amount with a reduced tenure. </div>
        <span class="text-link" (click)="addCoapplicants()">{{applicantLength > 1 ? 'Replace co-applicant' : 'Add co-applicant'}} </span>
      </div>
    </div>
</div>











